export default __webpack_public_path__ + "static/media/Alfajor-dulce-de-leche.e0aa35fc.jpg";